var _metadata, _defs, _clipPath, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg69",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata75"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs73"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g63",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "nonzero",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "nonzero",
    d: "M -6,0 H 342 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "nonzero",
    d: "M 17.036913,71.17821 H 242.42274 V 306.51679 H 17.036913 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "nonzero",
    d: "M 17.036913,71.17821 H 242.42274 V 306.51679 H 17.036913 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "nonzero",
    d: "m 273.45645,109.96049 h 46.2677 v 196.56694 h -46.2677 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "nonzero",
    d: "m 273.45645,109.96049 h 46.2677 v 196.56694 h -46.2677 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "nonzero",
    d: "m 31.55643,188.84772 v 0 c 0,-54.95017 43.953648,-99.49606 98.17323,-99.49606 v 0 c 26.03715,0 51.00789,10.48259 69.41894,29.14172 18.41106,18.65914 28.75428,43.96634 28.75428,70.35434 v 0 c 0,54.95017 -43.95365,99.49606 -98.17322,99.49606 v 0 c -54.219583,0 -98.173233,-44.5459 -98.173233,-99.49606 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "nonzero",
    d: "m 31.55643,188.84772 v 0 c 0,-54.95017 43.953648,-99.49606 98.17323,-99.49606 v 0 c 26.03715,0 51.00789,10.48259 69.41894,29.14172 18.41106,18.65914 28.75428,43.96634 28.75428,70.35434 v 0 c 0,54.95017 -43.95365,99.49606 -98.17322,99.49606 v 0 c -54.219583,0 -98.173233,-44.5459 -98.173233,-99.49606 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "nonzero",
    d: "m 45.42257,153.48425 h 202.51968 v 70.67717 H 45.42257 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "nonzero",
    d: "M 40.969852,95.99732 H 218.89111 v 185.7008 H 40.969852 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "nonzero",
    d: "M 40.969852,95.99732 H 218.89111 v 185.7008 H 40.969852 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "nonzero",
    d: "M 17.708662,72.89501 41.173229,95.950132",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "nonzero",
    d: "M 17.708662,72.89501 41.173229,95.950132",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "nonzero",
    d: "m 219.0971,281.69553 23.08662,24.28348",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "nonzero",
    d: "m 219.0971,281.69553 23.08662,24.28348",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "nonzero",
    d: "M 242.15749,72.89501 219.51181,95.950132",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "nonzero",
    d: "M 242.15749,72.89501 219.51181,95.950132",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "nonzero",
    d: "M 40.76378,281.70078 18.11811,304.75592",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "nonzero",
    d: "M 40.76378,281.70078 18.11811,304.75592",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "nonzero",
    d: "M 55.18635,58.892387 H 81.139105 V 71.17585 H 55.18635 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "nonzero",
    d: "M 55.18635,58.892387 H 81.139105 V 71.17585 H 55.18635 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "nonzero",
    d: "m 180.33595,58.892387 h 25.95276 V 71.17585 h -25.95276 z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fillRule: "nonzero",
    d: "m 180.33595,58.892387 h 25.95276 V 71.17585 h -25.95276 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fillRule: "nonzero",
    d: "m 84.14173,63.422573 h 92.25196 v 7.748028 H 84.14173 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fillRule: "nonzero",
    d: "m 84.14173,63.422573 h 92.25196 v 7.748028 H 84.14173 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text67",
    "aria-label": "[ TEXT ]"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 51.839844,171.08984 h 8.695312 v 2.93262 h -4.921875 v 31.58203 h 4.921875 v 2.93262 h -8.695312 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m 77.884766,172.38184 h 25.901364 v 3.48632 H 92.916992 V 203 h -4.163086 v -27.13184 h -10.86914 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 107.80566,172.38184 h 19.35938 v 3.48632 h -15.2168 v 9.06446 h 14.58106 v 3.48633 h -14.58106 v 11.09472 h 15.58594 V 203 h -19.72852 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 132.90723,172.38184 h 4.45019 l 7.6084,11.38183 7.64941,-11.38183 h 4.4502 l -9.84375,14.7041 10.5,15.91406 h -4.4502 L 144.6582,189.97754 135.9834,203 h -4.4707 l 10.93066,-16.34473 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m 158.19336,172.38184 h 25.90137 v 3.48632 H 173.22559 V 203 h -4.16309 v -27.13184 h -10.86914 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 210.13965,171.08984 v 37.44727 h -8.69531 v -2.93262 h 4.90136 v -31.58203 h -4.90136 v -2.93262 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonComponent);
export default __webpack_public_path__ + "static/media/ButtonComponent.599071cb7d5c18c84f35037b26201d12.svg";
export { ForwardRef as ReactComponent };